module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo4-1456dcfc8eafa3c307303ef17a78cff9.png";